/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Describeyourbusinessindetail4Inputs */

const en_describeyourbusinessindetail4 = /** @type {(inputs: Describeyourbusinessindetail4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe your business in detail...`)
};

const de_describeyourbusinessindetail4 = /** @type {(inputs: Describeyourbusinessindetail4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreib dein Unternehmen…`)
};

/**
* | output |
* | --- |
* | "Describe your business in detail..." |
*
* @param {Describeyourbusinessindetail4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const describeyourbusinessindetail4 = /** @type {((inputs?: Describeyourbusinessindetail4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Describeyourbusinessindetail4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_describeyourbusinessindetail4(inputs)
	return de_describeyourbusinessindetail4(inputs)
});
export { describeyourbusinessindetail4 as "describeYourBusinessInDetail" }